import axios from "axios";
import { localStorageItem } from './../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { OctResponse } from '../../models/OctResponse';
import { urlParamsConfig } from "../../utils/ParamsUtils";
import { getAuth } from "../../auth/core/AuthHelpers";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_CONFIG = API + "/config";
const API_HUB = API + "/hub";

export const searchDanhSachDVCungCapDv = (searchData: any): Promise<OctResponse<any>>  => {
  const url = `${API_CONFIG}` + `/search`;
  return axios.post(url, searchData)
};

export const callApiHub = (data: any, orgCode: string, orgProviderCode: string, serviceCode: string): Promise<OctResponse<any>>  => {
  const url = API_HUB + `/v1/request`;
  const auth = getAuth()
  // let config = {
  //   headers: {
  //     "hub-organization-code": orgCode,
  //     "hub-service-code": serviceCode,
  //     "hub-organization-provider-code": orgProviderCode,
  //     Authorization: `Bearer ${auth?.access_token}`
  //   }
  // }
  const api = axios.create({
    baseURL: url,
    headers: {
      'Content-Type': 'application/json',
      "hub-organization-code": orgCode,
      "hub-service-code": serviceCode,
      "hub-organization-provider-code": orgProviderCode,
      'Authorization': `Bearer ${auth?.access_token}`
    }
  });
  return api.post(url, data);
}